import React from 'react'
import mockup from '../Assets/mockup-tiktok.webp'
import Counter from '../Components/Counter'
import BtnDefault from '../Components/BtnDefault'
import AutoShowComponent from '../Components/AutoShowComponent'

const Tiktok = () => {
  return (
    <section id='tiktok-section' className='medium-checkered-background-dark text-white padding-50 flex-center text-dark'>
      <div className='flex-center flex__gap-100 mobile-flex__column-reverse'>
        <div className='flex-center flex-column flex__gap-30 flex__align-start wd-400 mobile-flex__column mobile-wd-90p'>
            <div>
                <div className='followers-container extra-bold mobile-justify-center'>
                  <Counter num1="2" num2="2" num3="2"/>
                  <h2 className='title-main'>Mil</h2>
                </div>
                <h2 className='subtitle-main'>Seguidores no Tiktok</h2>
            </div>
            <p className='paragraph-default'>No TikTok, Raffa Fragoso cria uma conexão especial com seus seguidores através de suas lives, onde compartilha momentos cantando ao vivo para um público fiel e engajado. Além das lives, ele posta trechos exclusivos desses momentos, vídeos cantando suas músicas favoritas e receitas rápidas e criativas. Com seu estilo autêntico e animado, Raffa transforma cada vídeo em uma oportunidade de inspirar e entreter sua audiência!
            </p>
            <BtnDefault socialMedia="Tiktok" link="https://www.tiktok.com/@raffaelfragoso"/>
        </div>
        <AutoShowComponent 
          srcImg={mockup} altImg='Mockup Tiktok' 
          width="190" 
          height="522"
        />
      </div>
    </section>
  )
}

export default Tiktok
